import { render, staticRenderFns } from "./uOttawa1321Lab3UnknownId.vue?vue&type=template&id=2d49d8d0&scoped=true&"
import script from "./uOttawa1321Lab3UnknownId.vue?vue&type=script&lang=ts&"
export * from "./uOttawa1321Lab3UnknownId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49d8d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VBtnToggle,VRadio,VRadioGroup})
